import { FormTypeBase } from './form-type-base';

export class FormTypeText extends FormTypeBase {

    constructor(options: {
        key?: string,
        fieldCode?: string,
        order?: number
    } = {}) {
        options['type'] = 'text';
        super(options);
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/models/form/form-type-text.ts